import { NgClass, NgFor, NgIf, UpperCasePipe } from '@angular/common';
import { Component, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { FieldWrapper, FormlyFieldConfig, FormlyModule } from '@ngx-formly/core';

@Component({
  selector: 'formly-wrapper-panel-documenti',
  template: `
<div class="flex flex-col bg-white border shadow-sm rounded-xl dark:bg-slate-900 dark:border-gray-700 dark:shadow-slate-700/[.7] mb-6">

    <div class="flex flex-row justify-between bg-primary border-b rounded-t-xl py-3 px-4 md:py-4 md:px-5">
      <p class=" text-white font-semibold text-md">
      {{ props.label | uppercase }}
      </p>

    <div class="flex items-center pl-10" *ngIf="isValid(field) && !form.dirty">
    <mat-icon class="icon-size-5 white-icon" matPrefix [svgIcon]="'heroicons_solid:check-circle'"></mat-icon>
    <p class="font-semibold text-sm text-white ml-2">{{'Dati completati' | uppercase}}</p>
    </div>


    <div class="flex items-center pl-10" *ngIf="form.dirty && isValid(field)">
    <mat-icon class="icon-size-5 white-icon" matPrefix [svgIcon]="'heroicons_solid:question-mark-circle'"></mat-icon>
    <p class="font-semibold text-sm text-white ml-2">{{'Dati modificati' | uppercase}}</p>
    </div>

    <div class="flex items-center pl-10" *ngIf="!isValid(field)">
    <mat-icon class="icon-size-5 white-icon" matPrefix [svgIcon]="'heroicons_solid:x-circle'"></mat-icon>
    <p class="font-semibold text-sm text-white ml-2">{{'dati da completare' | uppercase}}</p>
    </div>

    </div>

  <div class="sm:p-2 md:p-5">
    <p class="mt-2 text-gray-500 dark:text-gray-400">
      <ng-container #fieldComponent></ng-container>
    </p>

  </div>
</div>
  `,
  standalone: true,
  imports: [FormlyModule, NgIf, UpperCasePipe, MatIconModule, ReactiveFormsModule]
})
export class PanelDocumentiComponent extends FieldWrapper{
  @ViewChild('fieldComponent', { read: ViewContainerRef }) fieldComponent: ViewContainerRef;

  isValid(field: FormlyFieldConfig): boolean {
    //return true
    if (field.key) {
      return field.formControl.valid;
    }
    return field.fieldGroup ? field.fieldGroup.every((f) => f.hide || this.isValid(f)) || field.formControl.disabled  : true;
  }



}
